(async () => {
    const { Core } = await importModule('Core');
    const { NoUiSlider } = await importModule('NoUiSlider');

    customElements.define('collection-filter-price', class extends Core {
        elements = {
            slider: '[data-slider]',
            min: '[data-min]',
            max: '[data-max]',
            inputMin: '[data-input-min]',
            inputMax: '[data-input-max]'
        }

        render() {
            this._initSlider();
            this.slider.on('change',this._sliderChangeHanlder.bind(this));
        }

        _initSlider() {
            this.slider = NoUiSlider.create(this.$slider, {
                start: [
                    +this.getAttribute('current-min'),
                    +this.getAttribute('current-max')
                ],
                connect: true,
                range: {
                    min: +this.getAttribute('min'),
                    max: +this.getAttribute('max')
                }
            })
        }

        _sliderChangeHanlder([ min, max ],handle) {
            this.$inputMin.value = Math.round(min);
            this.$inputMax.value = Math.round(max);
            this.publish('filter:change');
            handle === 0 ? localStorage.setItem('id','.noUi-handle.noUi-handle-lower') : localStorage.setItem('id','.noUi-handle.noUi-handle-upper')

        }

        disconnect() {
            this.slider.destroy();
        }
    })
})();
